import { FC } from 'react';

import { GridApiPro } from '@mui/x-data-grid-pro';

import DataGridTable from '@/shared/components/dataDisplay/DataGridTable/DataGridTable';
import TableInstance from '@/shared/constants/tableInstance';
import ProductVariant from '@/shared/types/products/productVariant.type';

import ChooseLevelDropdown from './components/ChooseLevelDropdown';
import ShowSelectedRowsButton from './components/ShowSelectedRowsButton';
import useAssignProductsTable from './hooks/useAssignProductsTable';

type AssignProductsTableProps = {
  assignedVariants?: ProductVariant[];
  getSelectedRows?: (selectedRows: ProductVariant[]) => void;
  getSelectedLevel?: (level: 'products' | 'variants') => void;
};

const AssignProductsTable: FC<AssignProductsTableProps> = ({
  assignedVariants,
  getSelectedRows,
  getSelectedLevel,
}) => {
  const {
    loading,
    apiRef,
    model,
    table,
    level,
    columns,
    visibilityModel,
    showSelectedRows,
    setLevel,
    setVisibilityModel,
    setShowSelectedRows,
  } = useAssignProductsTable({ assignedVariants });

  return (
    <div style={{ height: '60vh', width: '100%' }}>
      <DataGridTable
        getRowId={(item) => item.variant_id as string}
        rowCount={table.totalRows}
        columns={columns}
        rows={table.data}
        loading={loading}
        columnVisibilityModel={visibilityModel}
        keepNonExistentRowsSelected={true}
        onColumnVisibilityModelChange={setVisibilityModel}
        onRowSelectionModelChange={(_, details) => {
          if ('api' in details) {
            const apiRef = details.api as GridApiPro;
            const selectedRows = apiRef.getSelectedRows();

            getSelectedRows?.([...selectedRows.values()] as ProductVariant[]);
          }
        }}
        customProps={{
          tableInstance: TableInstance.AssignProductsAndVariants,
          apiRef,
          model,
          toolbar: {
            toolbarFilters: (
              <>
                <ShowSelectedRowsButton
                  selectionModel={model.rowSelectionModel}
                  showSelectedRows={showSelectedRows}
                  setShowSelectedRows={setShowSelectedRows}
                />
                <ChooseLevelDropdown
                  level={level}
                  setLevel={(level) => {
                    setLevel(level);
                    getSelectedLevel?.(level);
                  }}
                />
              </>
            ),
          },
        }}
      />
    </div>
  );
};

export default AssignProductsTable;
